"use client";

import { LanguageProvider } from "../i18n";
import { PricingContent } from "./PricingContent";

export default function PricingPage() {
  return (
    <LanguageProvider initialLang="en">
      <PricingContent />
    </LanguageProvider>
  );
}
